export default __webpack_public_path__ + "static/media/WindowIcon.72408bd3.svg";